import { Button, Input, Spin, Table, TableProps } from "antd";
import React, { useEffect, useState } from "react";
import TitleBarComponent from "../../../components/titlebar/TitleBarComponent";
import { useAppDispatch, useAppSelector } from "../../../lib/hook";
import { ICustomer } from "../../../lib/features/customers/customers.constant";
import { onGetListCustomer } from "../../../lib/features/customers/customers.thunk";
import { removeVietnameseTones } from "../../../function/removeVietnameaseTones";
import ButtonAddCustomer from "./button/ButtonAddCustomer";
import { useNavigate } from "react-router-dom";

interface CustomersPageProps {
  // Add props here
}

const CustomersPage: React.FC<CustomersPageProps> = () => {
  const navigate = useNavigate();
  const { isGot, customers } = useAppSelector((store) => store?.customers);
  const [loading, setLoading] = useState<boolean>(false);
  const [searchText, setSearchText] = useState<string>("");
  const [filteredCustomers, setFilteredCustomers] = useState<ICustomer[]>([]);
  const dispatch = useAppDispatch();
  const handleGetListCustomer = async () => {
    setLoading(true);
    await dispatch(onGetListCustomer());
    setLoading(false);
  };
  useEffect(() => {
    if (!isGot) {
      handleGetListCustomer();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    setFilteredCustomers(customers);
  }, [customers]);
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchText(value);

    const keyword = removeVietnameseTones(value.toLowerCase());

    if (!keyword) {
      setFilteredCustomers(customers); // nếu trống thì hiển thị full
      return;
    }

    const filtered = customers.filter((user) => {
      const fullName = removeVietnameseTones(
        user.fullName?.toLowerCase() || ""
      );
      const reminiscient = removeVietnameseTones(
        user.shortNameNoAccent?.toLowerCase() || ""
      );
      return fullName.includes(keyword) || reminiscient.includes(keyword);
    });

    setFilteredCustomers(filtered);
  };
  const columns: TableProps<ICustomer>["columns"] = [
    {
      title: "Tên khách hàng",
      dataIndex: "fullName",
      key: "fullName",
    },
    {
      title: "Tên gợi nhớ",
      dataIndex: "shortName",
      key: "shortName",
    },
    {
      title: "Điện thoại",
      dataIndex: "phone",
      key: "phone",
      render: (_, record) => (
        <div className="flex flex-col gap-2">
          <p>Chính : {!!record?.majorPhone ? record?.majorPhone : "___"}</p>
          <p>Phụ : {!!record?.minorPhone ? record?.minorPhone : "___"}</p>
        </div>
      ),
    },

    {
      title: "Địa chỉ",
      dataIndex: "address",
      key: "address",
    },
    {
      title: "Action",
      key: "action",
      align: "end",
      render: (_, record) => (
        <div className="flex items-center gap-2 justify-end">
          <Button onClick={() => navigate(`${record?._id}`)}>Chi tiết</Button>
        </div>
      ),
    },
  ];
  return (
    <div>
      <TitleBarComponent
        title="Khách hàng"
        reload={() => handleGetListCustomer()}
        actionButton={<ButtonAddCustomer />}
      />
      <div className="flex justify-end">
        <Input
          size="middle"
          placeholder="Tìm kiếm..."
          value={searchText}
          onChange={handleSearchChange}
        />
      </div>
      {/* <div className="rounded-md border mt-3 hidden md:block">
        <Table<ICustomer>
          loading={loading}
          scroll={{ x: "max-content" }}
          columns={columns}
          dataSource={filteredCustomers}
          rowKey="_id" // hoặc customerId nếu bạn có
        />
      </div> */}
      {loading ? (
        <div className="flex flex-col gap-2 mt-3">
          <Spin tip="Đang tải...">
            <div className="rounded-md bg-white p-2 flex justify-between items-center">
              <div>
                <p className="font-medium text-base">
                  Văn Anh{" "}
                  <span className="text-xs text-gray-500">
                    ( Nguyễn Vân Anh )
                  </span>
                </p>
                <p className="font-medium text-xs line-clamp-2 text-gray-500 max-w-36">
                  123 Quận 6 TP.HCM
                </p>
              </div>
              <a
                href="/"
                className="inline-flex items-center justify-center bg-green-500 hover:bg-green-600 text-white font-medium h-10 w-10 rounded-full shadow transition-colors"
              >
                <i className="fa-solid fa-phone"></i>
              </a>
            </div>
            <div className="rounded-md bg-white p-2 flex justify-between items-center">
              <div>
                <p className="font-medium text-base">
                  Văn Anh{" "}
                  <span className="text-xs text-gray-500">
                    ( Nguyễn Vân Anh )
                  </span>
                </p>
                <p className="font-medium text-xs line-clamp-2 text-gray-500 max-w-36">
                  123 Quận 6 TP.HCM
                </p>
              </div>
              <a
                href="/"
                className="inline-flex items-center justify-center bg-green-500 hover:bg-green-600 text-white font-medium h-10 w-10 rounded-full shadow transition-colors"
              >
                <i className="fa-solid fa-phone"></i>
              </a>
            </div>
          </Spin>{" "}
        </div>
      ) : (
        <div className="flex flex-col gap-2 mt-3">
          {filteredCustomers?.map((item, key) => (
            <div
              key={key}
              className="rounded-xl bg-white p-2.5 flex justify-between items-center shadow-md active:scale-[0.97] active:bg-gray-100
                  transition-all duration-75"
            >
              <div
                className="max-w-[90%] flex flex-col gap-1 w-full"
                onClick={() => navigate(`${item?._id}`)}
              >
                <p className="font-bold text-xl">
                  {item?.shortName}{" "}
                  {!!item?.fullName && (
                    <span className="text-sm text-blue-700">
                      ( {item?.fullName} )
                    </span>
                  )}
                </p>
                <p className="font-medium text-sm line-clamp-2 text-gray-500  h-10 ">
                  {item?.address}
                </p>
              </div>
              <div>
                <a
                  href={`tel:${item?.majorPhone}`}
                  className="inline-flex items-center justify-center bg-green-500 hover:bg-green-600 text-white font-medium h-10 w-10 rounded-full shadow transition-colors"
                >
                  <i className="fa-solid fa-phone"></i>
                </a>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomersPage;
